// @flow

import type { UserState, SetUserIdentityAction, SetUserIdentityPayload } from './types';
import initialState from './initialState';
import { SET_USER_IDENTITY } from './actionTypes';

type UserAction = SetUserIdentityAction;

export default (state: UserState = initialState, action: UserAction) => {
  switch (action.type) {
    case SET_USER_IDENTITY:
      return ((payload: SetUserIdentityPayload) => ({
        ...state,
        userId: payload.userId,
      }))(action.payload);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/CaptureFeedback/user/reducer.js